import type { StackCreationType } from "@mirage/analytics/events/enums/stack_creation_type";
import { RoutePath } from "@mirage/webapp/routeTypes";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function useStacksNavigation() {
  const navigate = useNavigate();

  const navigateToStacks = useCallback(
    (query: string, creationType: StackCreationType = "manual") => {
      navigate(RoutePath.NEW_STACK, {
        state: {
          name: query,
          items: [],
          creationType,
        },
      });
    },
    [navigate],
  );

  return {
    navigateToStacks,
  };
}
